import { message} from "antd";
import { downloadProject } from "../../services/ide-apis";

function handleDownloadProject(projectObj){
    downloadProject(projectObj._id).then((response) => {
      const blob = new Blob([response.data], { type: 'application/zip' });
      const downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = `${projectObj.name}.zip`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    })
    .catch(() => {
      message.error('Failed to download project.');
    });
  }
  
export{
    handleDownloadProject,
}